import { Controller } from "@hotwired/stimulus";
import * as Plotly from "plotly.js-dist";

export default class extends Controller<HTMLElement> {
  static values = {
    data: Array,
    layout: Object,
  };

  declare readonly dataValue: object[];
  declare readonly layoutValue: object;

  connect() {
    Plotly.newPlot(this.element, this.dataValue, this.layoutValue || {}, {
      responsive: true,
    });
  }
}
